/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-20 14:46:07
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-09-21 11:14:38
 * @FilePath: \pit-bimwin-react-ui\src\components\PitRadio\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  FC,
  useState,
  CSSProperties,
  memo,
  useRef,
  useEffect,
} from 'react';
import styles from '../../styles/pitRadio.module.scss';
type BaseType = string | number | boolean;
interface PitRadioProps {
  value: BaseType;
  label?: BaseType;
  disabled?: boolean;
  // 靓丽色
  light?: boolean;
  style?: CSSProperties;
  onChange?(e: any): void;
}
const PitRadio: FC<PitRadioProps> = memo(
  ({ value, label, disabled, light, children, onChange }) => {
    let [model, setModel] = useState(value);
    const handleChange = (e: any) => {
      setModel(e.target.value);
      onChange && onChange(e.target.value);
    };
    useEffect(() => {
      setModel(value);
    }, [value]);
    const radio = useRef(null);
    return (
      <label
        className={`${styles['pit-radio']} ${
          model === label ? styles['pit-radio-checked'] : ''
        } ${disabled ? styles['pit-radio-disabled'] : ''} ${
          light ? styles['e-radio-light'] : ''
        }`}
      >
        <span className={styles['pit-radio__input']}>
          <span className={styles['pit-radio__inner']}>
            <div className={styles['in']}></div>
          </span>
          <input
            ref={radio}
            className={styles['pit-radio-original']}
            value={label as string}
            type="radio"
            aria-hidden="true"
            v-model="model"
            onClick={handleChange}
            tabIndex={-1}
            disabled={disabled}
          />
        </span>
        <span className={styles['pit-radio__label']}>{children || label}</span>
      </label>
    );
  }
);
export default PitRadio;
